import {remCalc} from '../../_utils'
import accordionStyle from '@salesforce/retail-react-app/app/theme/components/base/accordion'

export default {
    ...accordionStyle,
    baseStyle: {
        ...accordionStyle.baseStyle,
        button: {
            padding: '0',
            height: 'auto',
            _hover: {
                background: 'background.base.under',
                color: 'foreground.neutral.default',
            },
            // _expanded: {
            //     pb: [remCalc(8), remCalc(8), remCalc(8), remCalc(8)],
            // },
            justifyContent: 'space-between',
            flex: '1 0 0',
            alignItems: {base: 'center', md: 'flex-start'},
        },
        panel: {
            padding: '0',
            marginBottom: '0',
            marginTop: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        container: {
            borderColor: 'border.light',
        },
        title: {
            color: 'foreground.neutral.default',
            textStyle: 'body-medium',
            pb: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            textAlign: 'left',
            fontWeight: 'medium',
        },
        item: {
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            borderTop: 'none',
            maxW: '100%',
            cursor: 'pointer',
            _hover: {
                background: 'background.base.under',
                color: 'foreground.neutral.default',
            },
        },
        accordionStack: {
            width: '100%',
            direction: 'column',
            alignSelf: 'center',
            justifyContent: 'center',
            gap: 0,
            w: '100%',
        },
        accordionStackPaddingBot: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        accordionContainer: {
            alignSelf: 'center',
            width: '100%',
            spacing: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        accordionButtonTitle: {
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
            marginRight: ['small.lg', 'small.lg', 'medium.lg', 'medium.lg'],
            flex: '1',
            textAlign: 'left',
        },
        accordionButtonTitleStyle: {textStyle: 'body-small'},
        accordionButtonParagraphStyle: {textStyle: 'body-small'},
        accordionButtonTextDesktop: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            marginRight: ['0', '0', 'small.lg', 'small.lg'],
            flex: '1',
            textAlign: 'left',
            display: {base: 'none', md: 'block'},
        },
        accordionButtonTextMobile: {
            display: {base: 'block', md: 'none'},
            pt: remCalc(24),
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            marginRight: ['0', '0', 'small.lg', 'small.lg'],
            flex: '1',
            textAlign: 'left',
        },
        accordionPanelText: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
        },
        accordionPanelTextList: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            whiteSpace: 'normal',
            border: 0,
            p: 0,
            px: 0,
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
        },
        accordionPanelTextListValue: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
            whiteSpace: 'normal',
            border: 0,
            p: 0,
            px: 0,
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
        },
        accordionPanelElement: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flex: '1 0 0',
            alignItems: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            mb: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'xsmall-1.lg'],
            _last: {
                mb: 0,
                borderBottom: 0,
            },
            _first: {
                td: {
                    pt: 0,
                },
            },
            td: {
                textStyle: 'body-small',
                padding: 0,
                border: 'none',
                _first: {
                    color: 'foreground.neutral.subtle',
                },
            },
        },
        iconBox: {
            boxSize: 'iconsSize.small',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'transform 0.3s ease',
            color: 'foreground.neutral.default',
        },
        technicalSpecsIcon: {
            boxSize: remCalc(14),
            color: 'foreground.neutral.default',
            flexShrink: 0,
            mr: [remCalc(8), remCalc(8), remCalc(8), remCalc(8)],
        },
        addIconBox: {
            p: remCalc(6.4),
        },
        checkIconBox: {
            boxSize: 'iconsSize.medium',
            color: 'foreground.neutral.subtle',
        },
        accordionList: {
            spacing: ['small.lg'],
            marginLeft: 0,
            //styleType: 'none',
        },
        mainAccordion: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'center',
            paddingInline: 0,
            width: '100%',
        },
    },
    variants: {
        filterAccordion: {
            panel: {
                marginTop: 0,
            },
            container: {
                border: 'none',
                padding: 0,
                marginY: remCalc(11),
            },
        },
        productView: {
            checkIconBox: {
                boxSize: remCalc(14),
            },
        },
    },
    parts: [
        'container',
        'panel',
        'button',
        'title',
        'item',
        'accordionStack',
        'accordionContainer',
        'accordionButtonTitle',
        'accordionButtonText',
        'accordionButtonTextList',
        'accordionPanelElement',
        'iconBox',
        'checkIconBox',
        'accordionList',
        'accordionPanelText',
        'accordionPanelTextList',
        'accordionPanelTextListValue',
        'technicalSpecsIcon',
        'mainAccordion',
        'listItem',
    ],
}
